module.exports = __webpack_public_path__ + "static/img/messageCenter.2bb83139.png";